import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { ESigningOrderType } from "core/dto";
import { DsgDeepTranslationKey } from "projects/designer/src/app/pipes/translate.pipe";
import { distinctUntilChanged, map } from "rxjs";
import { DragCtxService } from "../../drag/drag-ctx.service";
import { SignProcessWizardService } from "../../sign-process-wizard.service";
import { ActivityCollectionService } from "./activity-collection/activity-collection.service";
import { SelectActivitiesStepService } from "./select-activities-step.service";



@Component({
  selector: 'ss-select-activities-step',
  templateUrl: './select-activities-step.component.html',
  styleUrls: ['./select-activities-step.component.css'],
  providers: [
    ActivityCollectionService,
    { provide: DragCtxService, useExisting: ActivityCollectionService }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectActivitiesStepComponent implements OnInit {

  readonly ESigningOrderType = ESigningOrderType

  readonly processSigningOrderSubject = this._signProcessWizardService.processSigningOrderSubject;

  readonly showNoActivitesErrorObs = this._selectActivitiesStepService.showNoActivitesErrorObs;
  get otherElements() {
    return this._signProcessWizardService.otherElements
  }
  get baseElement() {
    return this._signProcessWizardService.baseElement;
  }

  readonly valueObs = this.processSigningOrderSubject.pipe(
    distinctUntilChanged(),
    map((signingOrderType) => this.signingOrderTypeDataSource.find(({ value }) => value === signingOrderType))
  )

  readonly signingOrderTypeDataSource: { display: DsgDeepTranslationKey, value: any }[] = [
    { display: 'ss-entities.enum-signing-order-type.paralel', value: ESigningOrderType.paralel },
    { display: 'ss-entities.enum-signing-order-type.serial', value: ESigningOrderType.serial },
    { display: 'ss-entities.enum-signing-order-type.custom', value: ESigningOrderType.custom },
  ]

  constructor(
    private readonly _selectActivitiesStepService: SelectActivitiesStepService,
    private readonly _signProcessWizardService: SignProcessWizardService,
    private readonly _activityCollectionService: ActivityCollectionService

  ) { }

  ngOnInit(): void {
  }

  append(otherElements: any[]) {
    return [...this.otherElements, ...otherElements] as HTMLElement[]
  }

  addNewActivity() {
    this._activityCollectionService.addNewActivity();
  }
  addSelf() {

    this._activityCollectionService.addSelf()
  }
}
